import { ComponentChildren, h } from 'preact';
import styled from 'styled-components';

interface NavMenuProps {
  children: ComponentChildren;
}

export const breakpoints = {
  sm: '600px',
  md: '960px',
  lg: '1280px',
};

const Nav = styled.div`
  display: flex;
  gap: 10px;
  @media screen and (max-width: ${breakpoints.md}) {
    --gutter: 20px;
    display: grid;
    grid-gap: calc(var(--gutter) / 2);
    grid-template-rows: minmax(40px, 1fr);
    grid-auto-flow: column;
    overflow-x: auto;
    scroll-snap-type: x proximity;
  }
`;

export const NavMenu = ({ children }: NavMenuProps) => {
  return <Nav className="nav-menu">{children}</Nav>;
};
